export const SUPPORT_EMAIL = 'info@theartisan.ai';
